import { Box } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { t } from 'i18next'

export const useStyles = makeStyles(theme => ({
  text: {
    fontFamily: theme.corporate.primaryFont,
    color: theme.colors.gray600,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '18px',
    marginBottom: 16
  },

  error: {
    color: theme.colors.red01,
    fontSize: '18px',
    marginRight: '2px',
    lineHeight: '18px'
  }
}))

export default function RequiredText(): JSX.Element {
  const classes = useStyles()

  return (
    <Box display="flex" flexDirection="row" justifyContent="flex-end" className={classes.text}>
      <span className={classes.error}>*</span>
      <span>{t('form.errors.required_fields')}</span>
    </Box>
  )
}
